export default "__VITE_ASSET__d5ad8d3e__"